class FitContentDirective {
    constructor($timeout, $rootScope) {
        this.restrict = 'A';
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
    }

    link($scope, elem) {
        let mutationObserverTimeout = null;
        const parentElement = elem[0];
        const config = { attributes: true, childList: true };
        let transformOrigin = elem.attr('transform-origin') ? elem.attr('transform-origin') : 'top';

        const callback = (mutationsList, observer) => {
            if (mutationObserverTimeout) {
                this.$timeout.cancel(mutationObserverTimeout);
            }
            mutationObserverTimeout = this.$timeout(() => {
                this.setScale(parentElement, transformOrigin);
            }, 50);
        };

        const observer = new MutationObserver(callback);
        observer.observe(parentElement, config);
    }

    setScale(parentElement, transformOrigin) {
        const childElement = parentElement.firstElementChild;
        if (!childElement) {
            return;
        }
        const childChildElement = childElement.firstElementChild;

        console.log('setScale parentH = ', parentElement, parentElement.offsetHeight, 'childH = ', childElement.offsetHeight);

        if(childElement.offsetHeight > parentElement.offsetHeight) {
            const scale = parentElement.offsetHeight / childElement.offsetHeight;
            childElement.style.maxHeight = parentElement.offsetHeight;
            childChildElement.style.transform = `scale(${scale})`;
            childChildElement.style.transformOrigin = 'top';
            childChildElement.style.height = parentElement.offsetHeight + 'px';
        }

        childElement.classList.add('is-scaled');
    }

    static directiveFactory($timeout, $rootScope) {
        'ngInject';
        return new FitContentDirective($timeout, $rootScope);
    }
}

export default FitContentDirective;
